import { ChangeDetectionStrategy, Component, effect, input, model, output, ViewChild } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { DialogModule } from 'primeng/dialog';
import { PickList, PickListModule } from 'primeng/picklist';

@Component({
  selector: 'lib-device-picker-dialog',
  standalone: true,
  imports: [DialogModule, PickListModule, TranslocoModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <p-dialog
      [header]="header()"
      [(visible)]="visible"
      [modal]="true"
      [style]="{ width: '90vw', maxWidth: '900px' }"
      (onHide)="onDialogClose()"
      (onShow)="onDialogShow()">
      @if (visible()) {
        <p-pickList
          #pickListRef
          [source]="localSource"
          [target]="localTarget"
          [sourceHeader]="'siteConfiguration.devicePicker.available' | transloco"
          [targetHeader]="'siteConfiguration.devicePicker.selected' | transloco"
          [dragdrop]="false"
          [responsive]="true"
          filterBy="name"
          [sourceFilterPlaceholder]="'siteConfiguration.devicePicker.searchByName' | transloco"
          [targetFilterPlaceholder]="'siteConfiguration.devicePicker.searchByName' | transloco">
          <ng-template let-item pTemplate="item">
            <div class="flex items-center gap-2 p-2">
              <i
                [class]="deviceType() === 'Gateways' ? 'pi pi-broadcast' : 'pi pi-compass'"
                class="text-gray-400 dark:text-slate-500"></i>
              <div>
                <span class="block text-sm font-medium">{{ item?.name }}</span>
                <span class="block text-xs text-gray-500 dark:text-slate-400">{{ item?.deviceId }}</span>
              </div>
            </div>
          </ng-template>
        </p-pickList>
      }
    </p-dialog>
  `,
})
export class DevicePickerDialogComponent {
  /** Titre déjà traduit par l'appelant. */
  header = input<string>('');
  /** Type de device listé (icône) ; seul 'Gateways' est utilisé, les en-têtes parlent de gateways. */
  deviceType = input<string>('Gateways');
  source = input<any[]>([]);
  target = input<any[]>([]);
  visible = model<boolean>(false);

  selectionChanged = output<{ source: any[]; target: any[] }>();

  @ViewChild('pickListRef') pickListRef?: PickList;

  localSource: any[] = [];
  localTarget: any[] = [];

  constructor() {
    effect(() => {
      const v = this.visible();
      if (v) {
        this.localSource = [...this.source()];
        this.localTarget = [...this.target()];
      }
    });
  }

  onDialogShow(): void {
    // Patch PrimeNG PickList's buggy ngAfterViewChecked to prevent scrollInView crash
    setTimeout(() => {
      if (this.pickListRef) {
        const original = this.pickListRef.ngAfterViewChecked.bind(this.pickListRef);
        this.pickListRef.ngAfterViewChecked = () => {
          try {
            original();
          } catch {
            // Ignoré.
          }
        };
      }
    });
  }

  onDialogClose(): void {
    const uniqueTarget = [...new Map(this.localTarget.map((item: any) => [item.id, item])).values()];
    this.selectionChanged.emit({
      source: [...this.localSource],
      target: uniqueTarget,
    });
  }
}
